import "./NurseInTelAvivWithinHours.module.css";
import Header from "@/reusable_sections/Header";
import Problem from "./sections/Problem";
import Solution from "./sections/Solution";
import UniqueDifferenceIsraelisOnly from "./sections/UniqueDifferenceIsraelisOnly";
import ServicesPresentation from "./sections/ServicesPresentation";
import Footer from "@/reusable_sections/Footer";
export default function NurseInTelAvivWithinHoursPage() {
  return <div>
      <Header />
      <Problem />
      <Solution />
      <UniqueDifferenceIsraelisOnly />
      <ServicesPresentation />
      <Footer />
    </div>;
}